module.exports = __webpack_public_path__ + "static/media/workingmemory-words-6.36027658.mp3";